import React from "react";

export default function PlusCircleIcon(props?: any) {
  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
    .filter((key) => svgStyles[key] !== null && svgStyles[key] !== undefined)
    .reduce((acc: any, key) => {
      acc[key] = svgStyles[key];
      return acc;
    }, {});

  return (
    <svg viewBox="0 0 26 26" style={{ ...filteredStyles, fill: "none" }} className={props.className} xmlns="http://www.w3.org/2000/svg">
      <circle cx="13" cy="13" r="12.5" stroke={filteredStyles.fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0035 9C14.0035 8.44772 13.5557 8 13.0035 8C12.4512 8 12.0035 8.44772 12.0035 9V12.0035H9C8.44772 12.0035 8 12.4512 8 13.0035C8 13.5557 8.44772 14.0035 9 14.0035H12.0035V17.0073C12.0035 17.5596 12.4512 18.0073 13.0035 18.0073C13.5557 18.0073 14.0035 17.5596 14.0035 17.0073V14.0035H17.0073C17.5596 14.0035 18.0073 13.5557 18.0073 13.0035C18.0073 12.4512 17.5596 12.0035 17.0073 12.0035H14.0035V9Z"
        fill={filteredStyles.fill}
      />
    </svg>
  );
}
